import React from 'react';

import classNames from 'classnames';

import { FxRate, sectionIncomplete, withIncomplete } from '../ShowInSelect';

import { formatCell, isEmptyCell } from './summaryCellFormat';

// Column-generic Cashflow table (IB-642): renders the period `columns` (M/Q/Y)
// left→right with a Total column, a net row per selected project, and a
// semantic-coloured Net total row.
export default function CashflowTable({ data, columns, fx = null }) {
    if (!columns || columns.length === 0 || !data) {
        return null;
    }

    const children = data.children || [];

    return (
        <div className="inbud-table_wrapper inbud-table_sticky-box tw-mt-6">
            <table className="inbud-table tw-table-fixed inbud-table_two-sticky-left">
                <thead>
                    <tr>
                        <th className="tw-w-56 tw-sticky tw-left-0 tw-h-fit">{$t('Event')}</th>
                        <th className="tw-w-32 tw-sticky tw-left-56 tw-h-fit">{$t('Total')}</th>
                        {columns.map((column) => (
                            <th className="tw-w-32" key={column.key}>
                                {column.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <CashflowRows rows={children} columns={columns} />
                </tbody>
                {/* Net is the bottom-line total, pinned to the bottom of the scroll box (IB-697). */}
                <tfoot>
                    <Row
                        name={withIncomplete(fx ? $t('Net ({{currency}})', { currency: fx.show_in }) : $t('Net'), sectionIncomplete(children))}
                        row={data}
                        columns={columns}
                        locale={fx?.locale || null}
                        semantic
                        bold
                    />
                </tfoot>
            </table>
        </div>
    );
}

function CashflowRows({ rows, columns }) {
    return rows.map((row, index) => (
        <Row
            key={`cashflow-${index}`}
            name={
                row.fx?.missing ? (
                    <span className="tw-inline-flex tw-flex-wrap tw-items-center tw-gap-2">
                        {row.name}
                        <FxRate fx={row.fx} />
                    </span>
                ) : (
                    row.name
                )
            }
            row={row}
            columns={columns}
            locale={row.fx ? row.locale : null}
            semantic
        />
    ));
}

function Row({ name, row, columns, locale = null, semantic = false, bold = false }) {
    return (
        <tr>
            <td className="tw-sticky tw-left-0 tw-h-fit">
                <span className={classNames({ 'tw-font-medium': bold })}>{name}</span>
            </td>
            <Cell value={row.total} semantic={semantic} bold={bold} locale={locale} sticky />
            {columns.map((column) => (
                <Cell key={column.key} value={row.columns?.[column.key]?.total} semantic={semantic} bold={bold} locale={locale} />
            ))}
        </tr>
    );
}

function Cell({ value, semantic = false, bold = false, sticky = false, locale = null }) {
    const formatted = formatCell(value, false, locale);
    const isEmpty = isEmptyCell(formatted);
    const colour = semantic && !isEmpty ? (value >= 0 ? 'tw-text-green' : 'tw-text-red') : null;

    return (
        <td
            className={classNames('inbud-numeric-cell', colour, {
                'tw-sticky tw-left-56 tw-h-fit': sticky,
                'tw-font-medium': bold,
            })}
        >
            {formatted}
        </td>
    );
}
